import { KybFieldName } from '../../constants'

export const isFieldRequired = (requiredFields: Array<string>, fieldName: KybFieldName) =>
  requiredFields?.includes(fieldName)
